// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hIGL","rootMobile":"styles_rootMobile__28cuJ"};